export default __webpack_public_path__ + "static/media/bedroom2.03ec85a0.jpg";